/**
 * 九宫飞星的纯展示模型。
 *
 * 这一层只把 src/feixing.js 的排盘事实组织成环上 token 和悬停文案，
 * 不向 analyze()/verdict()/timing.js 回写任何数据。
 */

import { feixing, FLYING_STARS } from '../src/feixing.js';

/** 屏幕正上为南，按屏幕顺时针排列，与后天八卦环同位。 */
export const FLYING_STAR_RING_PALACES = Object.freeze([
  '离', '坤', '兑', '乾', '坎', '艮', '震', '巽'
]);

export const FLYING_STAR_NOTE = '玄空飞星，与六爻纳甲为两套体系，不参与本卦断语。';
export const FLYING_STAR_DAY_NOTE = '日盘采用「冬至后第一个甲子」说，四家无定论，此为工程选择。';

const toneOf = (star) => {
  if (star === 2 || star === 5) return 'crimson';
  if (star === 1 || star === 8 || star === 9) return 'gold';
  return 'normal';
};

const scaleLabel = (scale) => (scale === 'month' ? '月盘' : '年盘');

function starText(star) {
  const info = FLYING_STARS[star];
  return `${star} ${info.name}，${info.element}`;
}

function tooltipFor(palace, chart) {
  return {
    title: `${palace}宫 · 玄空飞星`,
    lines: [
      `年星：${starText(chart.stars[palace].year)}`,
      `月星：${starText(chart.stars[palace].month)}`,
      `日星：${starText(chart.stars[palace].day)}（${chart.day.dun}）`,
      `日盘锚点：${chart.day.anchor.term}后甲子日，相距 ${chart.day.daysFromAnchor} 日`
    ],
    note: `${FLYING_STAR_DAY_NOTE}\n${FLYING_STAR_NOTE}`
  };
}

/**
 * 生成一份可直接交给 Field 的展示模型。
 * scale 只决定环上当前显示年星还是月星，悬停始终同时列出两盘。
 */
export function flyingStarRingModel(at, scale = 'year') {
  const activeScale = scale === 'month' ? 'month' : 'year';
  const chart = feixing(at);
  const makeToken = (palace) => {
    const star = chart.stars[palace][activeScale];
    const info = FLYING_STARS[star];
    return {
      label: palace,
      text: `${palace}${star}${info.name}`,
      palace,
      star,
      starName: info.name,
      element: info.element,
      tone: toneOf(star),
      tooltip: tooltipFor(palace, chart)
    };
  };

  return {
    scale: activeScale,
    scaleLabel: scaleLabel(activeScale),
    chart,
    ringTokens: FLYING_STAR_RING_PALACES.map(makeToken),
    center: makeToken('中')
  };
}
